import { Card, Typography } from 'antd'
import React, { Children } from 'react'

const ZCard = ({ children, className = "", ...rest }) => {
    return (
        <Card className={`z-card ${className}`} {...rest}>{children}</Card>
    )
}

const Title = ({ children, className="", level = 5, ...rest }) => {
    return <Typography.Title level={level} className={`pb-16 ${className} `} {...rest}>{children}</Typography.Title>;
}

ZCard.Title = Title;

export default ZCard